module.exports = __webpack_public_path__ + "img/2025-02-13d_1.1f539dda.jpg";